module.exports = __webpack_public_path__ + "static/media/gts32.ad4c1e88.png";